import React, { FC } from 'react';
import SettingsIco from '@mui/icons-material/Settings';
import { useTranslation } from 'react-i18next';
import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { IconButton, Stack, styled } from '@mui/material';
import { dictionaryState } from '../../../../../../../../shared/components/dictionary/states/dictionary.state.ts';
import { SValue } from '../../../../../../../order/common/orderGridItems/cells/product/product.cell.tsx';
import { Popup } from '../../../../../../../../shared/components/popup/popup.abstract.tsx';
import { ISubCompanySettingPopup } from '../popup/subCompanySetting.popup.tsx';

export const NameSubCompany: FC<TNameSubCompany> = ({ value, row, id, popupStream }) => {
  const { t } = useTranslation();
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    dictionaryState.pub.selectRow(row);
    popupStream.emit('open', { id: String(id), title: row.companyName });
  };

  return (
    <SStack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
      <SValue>{value}</SValue>
      <IconButton
        className='button'
        disabled={row.invalid || String(id).includes('new')}
        title={t('customer.company')}
        onClick={handleClick}
        sx={{ p: '3.5px' }}
        size='small'
      >
        <SettingsIco />
      </IconButton>
    </SStack>
  );
};

const SStack = styled(Stack)({});

type TNameSubCompany = GridRenderCellParams & {
  popupStream: Popup<ISubCompanySettingPopup>['stream'];
};
